// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let FormV5 = require("../../uikit/reason/atoms/Form/FormV5.bs.js");
let Scalars = require("../../scalars/Scalars.bs.js");
let DialogV5 = require("../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
let RelayEnv = require("../../RelayEnv.bs.js");
let AgentInfo = require("../common/Agent/AgentInfo.bs.js");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Formality = require("@tan/formality/src/Formality.bs.js");
let View__Jsx3 = require("../../uikit/reason/helpers/View__Jsx3.bs.js");
let Form__Input = require("../../uikit/reason/atoms/Form/Form__Input.bs.js");
let Form__Helpers = require("../../reason/common/Form/Form__Helpers.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Form__Components = require("../../reason/common/Form/Form__Components.bs.js");
let Form__Validators = require("../../reason/common/Form/Form__Validators.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let InlineWarning__Jsx3 = require("../../uikit/reason/atoms/InlineWarning/InlineWarning__Jsx3.bs.js");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let Formality__Debouncer = require("@tan/formality/src/Formality__Debouncer.bs.js");
let Primitive_exceptions = require("@rescript/runtime/lib/js/Primitive_exceptions.js");
let Formality__ReactUpdate = require("@tan/formality/src/Formality__ReactUpdate.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let ProfilePagePersonalInformationForm_agent_graphql = require("../../__generated__/ProfilePagePersonalInformationForm_agent_graphql.bs.js");
let ProfilePagePersonalInformationFormEmailQuery_graphql = require("../../__generated__/ProfilePagePersonalInformationFormEmailQuery_graphql.bs.js");
let ProfilePagePersonalInformationForm_UpdateAgentProfileCompanyMutation_graphql = require("../../__generated__/ProfilePagePersonalInformationForm_UpdateAgentProfileCompanyMutation_graphql.bs.js");
let ProfilePagePersonalInformationForm_UpdateAgentProfilePersonalInfoMutation_graphql = require("../../__generated__/ProfilePagePersonalInformationForm_UpdateAgentProfilePersonalInfoMutation_graphql.bs.js");

let convertVariables = ProfilePagePersonalInformationForm_UpdateAgentProfileCompanyMutation_graphql.Internal.convertVariables;

let convertResponse = ProfilePagePersonalInformationForm_UpdateAgentProfileCompanyMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = ProfilePagePersonalInformationForm_UpdateAgentProfileCompanyMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, ProfilePagePersonalInformationForm_UpdateAgentProfileCompanyMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, ProfilePagePersonalInformationForm_UpdateAgentProfileCompanyMutation_graphql.node, convertResponse, convertWrapRawResponse);

let UpdateAgentProfileCompanyMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

function ProfilePagePersonalInformationForm$ForceBrokerageDialog(props) {
  let setCompanyInForm = props.setCompanyInForm;
  let match = use();
  let mutate = match[0];
  let match$1 = React.useState(() => false);
  let setMutationErrored = match$1[1];
  let match$2 = React.useState(() => "");
  let setBrokerage = match$2[1];
  let brokerage = match$2[0];
  let submit = () => {
    mutate({
      input: {
        company: brokerage
      }
    }, undefined, undefined, undefined, (response, param) => {
      let match = response.updateAgentProfileCompany;
      if (match !== undefined) {
        setCompanyInForm(brokerage);
        return setMutationErrored(param => false);
      } else {
        return setMutationErrored(param => true);
      }
    }, undefined, undefined);
  };
  return JsxRuntime.jsxs(DialogV5.make, {
    title: "Set Your Brokerage",
    isOpen: Stdlib_Option.isNone(Stdlib_Option.flatMap(Stdlib_Option.map(props.company, c => c.trim()), Form__Helpers.opt_of_string)),
    ariaLabel: "Set your Brokerage",
    onDismiss: prim => {},
    showCloseButton: false,
    children: [
      JsxRuntime.jsx("div", {
        children: "Your profile is missing your brokerage information. Which brokerage do you belong to?",
        className: "leading-normal"
      }),
      match$1[0] ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx(View__Jsx3.make, {
              mb: "md"
            }),
            JsxRuntime.jsx(InlineWarning__Jsx3.make, {
              children: "There was a problem setting your brokerage. Please try again..."
            })
          ]
        }) : null,
      JsxRuntime.jsx(View__Jsx3.make, {
        mb: "md"
      }),
      JsxRuntime.jsx(Form__Input.make, {
        onChange: evt => {
          let value = evt.target.value;
          setBrokerage(param => value);
        },
        value: brokerage
      }),
      JsxRuntime.jsx(View__Jsx3.make, {
        mt: "md",
        justifyContent: "flexEnd",
        flexDirection: "row",
        children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
          onClick: param => submit(),
          disabled: brokerage.trim() === "" || match[1],
          children: "Save"
        })
      })
    ]
  });
}

let ForceBrokerageDialog = {
  UpdateAgentProfileCompanyMutation: UpdateAgentProfileCompanyMutation,
  make: ProfilePagePersonalInformationForm$ForceBrokerageDialog
};

let convertVariables$1 = ProfilePagePersonalInformationFormEmailQuery_graphql.Internal.convertVariables;

let convertResponse$1 = ProfilePagePersonalInformationFormEmailQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = ProfilePagePersonalInformationFormEmailQuery_graphql.Internal.convertWrapRawResponse;

let use$1 = RescriptRelay_Query.useQuery(convertVariables$1, ProfilePagePersonalInformationFormEmailQuery_graphql.node, convertResponse$1);

let useLoader = RescriptRelay_Query.useLoader(convertVariables$1, ProfilePagePersonalInformationFormEmailQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(ProfilePagePersonalInformationFormEmailQuery_graphql.node, convertResponse$1, prim => prim);

let fetch = RescriptRelay_Query.fetch_(ProfilePagePersonalInformationFormEmailQuery_graphql.node, convertResponse$1, convertVariables$1);

let fetchPromised = RescriptRelay_Query.fetchPromised(ProfilePagePersonalInformationFormEmailQuery_graphql.node, convertResponse$1, convertVariables$1);

let retain = RescriptRelay_Query.retain(ProfilePagePersonalInformationFormEmailQuery_graphql.node, convertVariables$1);

let Query_emailRegistrationStatus_decode = ProfilePagePersonalInformationFormEmailQuery_graphql.Utils.emailRegistrationStatus_decode;

let Query_emailRegistrationStatus_fromString = ProfilePagePersonalInformationFormEmailQuery_graphql.Utils.emailRegistrationStatus_fromString;

let Query = {
  emailRegistrationStatus_decode: Query_emailRegistrationStatus_decode,
  emailRegistrationStatus_fromString: Query_emailRegistrationStatus_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  use: use$1,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

async function validate(email, initialEmail) {
  if (email === initialEmail) {
    return {
      TAG: "Ok",
      _0: undefined
    };
  }
  let val;
  try {
    val = await fetchPromised(RelayEnv.environment, {
      email: email
    }, undefined, "network-only");
  } catch (raw_exn) {
    let exn = Primitive_exceptions.internalToException(raw_exn);
    if (exn.RE_EXN_ID === "JsExn") {
      return {
        TAG: "Error",
        _0: "something went wrong"
      };
    }
    throw exn;
  }
  let match = val.emailRegistrationStatus;
  if (match === undefined) {
    return {
      TAG: "Error",
      _0: "email is not available"
    };
  }
  let tmp = match.status;
  if (tmp === "AVAILABLE") {
    return {
      TAG: "Ok",
      _0: undefined
    };
  } else {
    return {
      TAG: "Error",
      _0: "email is not available"
    };
  }
}

let ValidateEmailAsync = {
  Query: Query,
  validate: validate
};

let validators_email = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => {
    let email = Form__Helpers.noneIfEmpty(param.email);
    if (email === undefined) {
      return {
        TAG: "Error",
        _0: "is required"
      };
    }
    let email$1 = Scalars.EmailAddress.validate(email);
    if (email$1.TAG === "Ok") {
      return {
        TAG: "Ok",
        _0: email$1._0
      };
    } else {
      return {
        TAG: "Error",
        _0: "Please enter a valid email."
      };
    }
  },
  validateAsync: Formality__Debouncer.make(700, param => {
    let dispatch = param[2];
    let value = param[0];
    let validate = (email, param) => param.validateEmail(Scalars.EmailAddress.toString(email), param.initialEmail).then(res => {
      if (res.TAG === "Ok") {
        return {
          TAG: "Ok",
          _0: email
        };
      } else {
        return {
          TAG: "Error",
          _0: res._0
        };
      }
    });
    Formality.Async.validateAsyncWithMetadata(value, param[1], validate, res => dispatch({
      TAG: "ApplyAsyncResultForEmailField",
      _0: value,
      _1: res
    }));
  }),
  eq: (a, b) => a === b
};

let validators_phone = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => {
    let phone = Form__Helpers.noneIfEmpty(param.phone);
    if (phone === undefined) {
      return {
        TAG: "Ok",
        _0: undefined
      };
    }
    let err = Form__Validators.isPhone(phone);
    if (err.TAG === "Ok") {
      if (err._0 === "Valid") {
        return {
          TAG: "Ok",
          _0: phone
        };
      } else {
        return {
          TAG: "Ok",
          _0: undefined
        };
      }
    } else {
      return {
        TAG: "Error",
        _0: err._0
      };
    }
  }
};

let validators_website = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => {
    let website = Form__Helpers.noneIfEmpty(param.website);
    if (website === undefined) {
      return {
        TAG: "Ok",
        _0: undefined
      };
    }
    let website$1 = Scalars.URL.fromString(website);
    if (website$1.TAG === "Ok") {
      return {
        TAG: "Ok",
        _0: Primitive_option.some(website$1._0)
      };
    } else {
      return {
        TAG: "Error",
        _0: "Please enter a valid URL."
      };
    }
  }
};

let validators_company = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => {
    let company = Form__Helpers.noneIfEmpty(param.company);
    if (company !== undefined) {
      return {
        TAG: "Ok",
        _0: company
      };
    } else {
      return {
        TAG: "Error",
        _0: "is required"
      };
    }
  }
};

let validators_displayName = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => ({
    TAG: "Ok",
    _0: param.displayName
  })
};

let validators_lastName = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => {
    let lastName = Form__Helpers.noneIfEmpty(param.lastName);
    if (lastName !== undefined) {
      return {
        TAG: "Ok",
        _0: lastName
      };
    } else {
      return {
        TAG: "Error",
        _0: "is required"
      };
    }
  }
};

let validators_firstName = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => {
    let firstName = Form__Helpers.noneIfEmpty(param.firstName);
    if (firstName !== undefined) {
      return {
        TAG: "Ok",
        _0: firstName
      };
    } else {
      return {
        TAG: "Error",
        _0: "is required"
      };
    }
  }
};

let validators = {
  email: validators_email,
  phone: validators_phone,
  website: validators_website,
  company: validators_company,
  displayName: validators_displayName,
  lastName: validators_lastName,
  firstName: validators_firstName
};

function initialFieldsStatuses(input) {
  return {
    email: "Pristine",
    phone: "Pristine",
    website: "Pristine",
    company: "Pristine",
    displayName: "Pristine",
    lastName: "Pristine",
    firstName: "Pristine"
  };
}

let initialFieldStatuses_xxx = initialFieldsStatuses;

function initialState(input) {
  return {
    input: input,
    fieldsStatuses: initialFieldsStatuses(input),
    collectionsStatuses: undefined,
    formStatus: "Editing",
    submissionStatus: "NeverSubmitted"
  };
}

function validateForm(input, validators, fieldsStatuses, metadata) {
  let value = fieldsStatuses.email;
  let tmp;
  tmp = typeof value !== "object" ? ({
      NAME: "Result",
      VAL: validators.email.validate(input, metadata)
    }) : (
      value.TAG === "Dirty" ? ({
          NAME: "Result",
          VAL: value._0
        }) : ({
          NAME: "Validating",
          VAL: value._0
        })
    );
  let match = fieldsStatuses.phone;
  let tmp$1;
  tmp$1 = typeof match !== "object" ? validators.phone.validate(input, metadata) : match._0;
  let match$1 = fieldsStatuses.website;
  let tmp$2;
  tmp$2 = typeof match$1 !== "object" ? validators.website.validate(input, metadata) : match$1._0;
  let match$2 = fieldsStatuses.company;
  let tmp$3;
  tmp$3 = typeof match$2 !== "object" ? validators.company.validate(input, metadata) : match$2._0;
  let match$3 = fieldsStatuses.displayName;
  let tmp$4;
  tmp$4 = typeof match$3 !== "object" ? validators.displayName.validate(input, metadata) : match$3._0;
  let match$4 = fieldsStatuses.lastName;
  let tmp$5;
  tmp$5 = typeof match$4 !== "object" ? validators.lastName.validate(input, metadata) : match$4._0;
  let match$5 = fieldsStatuses.firstName;
  let tmp$6;
  tmp$6 = typeof match$5 !== "object" ? validators.firstName.validate(input, metadata) : match$5._0;
  let emailResult = tmp;
  if (emailResult.NAME !== "Result") {
    return {
      TAG: "Validating",
      fieldsStatuses: {
        email: emailResult.NAME === "Result" ? ({
            TAG: "Dirty",
            _0: emailResult.VAL,
            _1: "Shown"
          }) : ({
            TAG: "Validating",
            _0: emailResult.VAL
          }),
        phone: {
          TAG: "Dirty",
          _0: tmp$1,
          _1: "Shown"
        },
        website: {
          TAG: "Dirty",
          _0: tmp$2,
          _1: "Shown"
        },
        company: {
          TAG: "Dirty",
          _0: tmp$3,
          _1: "Shown"
        },
        displayName: {
          TAG: "Dirty",
          _0: tmp$4,
          _1: "Shown"
        },
        lastName: {
          TAG: "Dirty",
          _0: tmp$5,
          _1: "Shown"
        },
        firstName: {
          TAG: "Dirty",
          _0: tmp$6,
          _1: "Shown"
        }
      },
      collectionsStatuses: undefined
    };
  }
  let emailResult$1 = emailResult.VAL;
  let emailResult$2;
  if (emailResult$1.TAG === "Ok") {
    let phoneResult = tmp$1;
    if (phoneResult.TAG === "Ok") {
      let websiteResult = tmp$2;
      if (websiteResult.TAG === "Ok") {
        let companyResult = tmp$3;
        if (companyResult.TAG === "Ok") {
          let displayNameResult = tmp$4;
          if (displayNameResult.TAG === "Ok") {
            let lastNameResult = tmp$5;
            if (lastNameResult.TAG === "Ok") {
              let firstNameResult = tmp$6;
              if (firstNameResult.TAG === "Ok") {
                return {
                  TAG: "Valid",
                  output: {
                    firstName: firstNameResult._0,
                    lastName: lastNameResult._0,
                    displayName: displayNameResult._0,
                    company: companyResult._0,
                    website: websiteResult._0,
                    phone: phoneResult._0,
                    email: emailResult$1._0
                  },
                  fieldsStatuses: {
                    email: {
                      TAG: "Dirty",
                      _0: emailResult$1,
                      _1: "Shown"
                    },
                    phone: {
                      TAG: "Dirty",
                      _0: phoneResult,
                      _1: "Shown"
                    },
                    website: {
                      TAG: "Dirty",
                      _0: websiteResult,
                      _1: "Shown"
                    },
                    company: {
                      TAG: "Dirty",
                      _0: companyResult,
                      _1: "Shown"
                    },
                    displayName: {
                      TAG: "Dirty",
                      _0: displayNameResult,
                      _1: "Shown"
                    },
                    lastName: {
                      TAG: "Dirty",
                      _0: lastNameResult,
                      _1: "Shown"
                    },
                    firstName: {
                      TAG: "Dirty",
                      _0: firstNameResult,
                      _1: "Shown"
                    }
                  },
                  collectionsStatuses: undefined
                };
              }
              emailResult$2 = emailResult$1;
            } else {
              emailResult$2 = emailResult$1;
            }
          } else {
            emailResult$2 = emailResult$1;
          }
        } else {
          emailResult$2 = emailResult$1;
        }
      } else {
        emailResult$2 = emailResult$1;
      }
    } else {
      emailResult$2 = emailResult$1;
    }
  } else {
    emailResult$2 = emailResult$1;
  }
  return {
    TAG: "Invalid",
    fieldsStatuses: {
      email: {
        TAG: "Dirty",
        _0: emailResult$2,
        _1: "Shown"
      },
      phone: {
        TAG: "Dirty",
        _0: tmp$1,
        _1: "Shown"
      },
      website: {
        TAG: "Dirty",
        _0: tmp$2,
        _1: "Shown"
      },
      company: {
        TAG: "Dirty",
        _0: tmp$3,
        _1: "Shown"
      },
      displayName: {
        TAG: "Dirty",
        _0: tmp$4,
        _1: "Shown"
      },
      lastName: {
        TAG: "Dirty",
        _0: tmp$5,
        _1: "Shown"
      },
      firstName: {
        TAG: "Dirty",
        _0: tmp$6,
        _1: "Shown"
      }
    },
    collectionsStatuses: undefined
  };
}

function useForm(initialInput, metadata, onSubmit) {
  let memoizedInitialState = React.useMemo(() => initialState(initialInput), [initialInput]);
  let match = Formality__ReactUpdate.useReducer(memoizedInitialState, (state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "BlurEmailField" :
          let result = Formality.Async.validateFieldOnBlurWithMetadata(state.input, metadata, state.fieldsStatuses.email, validators_email, status => {
            let init = state.fieldsStatuses;
            return {
              email: status,
              phone: init.phone,
              website: init.website,
              company: init.company,
              displayName: init.displayName,
              lastName: init.lastName,
              firstName: init.firstName
            };
          });
          if (result === undefined) {
            return "NoUpdate";
          }
          let value = result.email;
          if (typeof value === "object" && value.TAG !== "Dirty") {
            let value$1 = value._0;
            return {
              TAG: "UpdateWithSideEffects",
              _0: {
                input: state.input,
                fieldsStatuses: result,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              },
              _1: param => validators_email.validateAsync([
                value$1,
                metadata,
                param.dispatch
              ])
            };
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: result,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
          break;
        case "BlurPhoneField" :
          let result$1 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.phone, validators_phone, status => {
            let init = state.fieldsStatuses;
            return {
              email: init.email,
              phone: status,
              website: init.website,
              company: init.company,
              displayName: init.displayName,
              lastName: init.lastName,
              firstName: init.firstName
            };
          });
          if (result$1 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$1,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurWebsiteField" :
          let result$2 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.website, validators_website, status => {
            let init = state.fieldsStatuses;
            return {
              email: init.email,
              phone: init.phone,
              website: status,
              company: init.company,
              displayName: init.displayName,
              lastName: init.lastName,
              firstName: init.firstName
            };
          });
          if (result$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$2,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurCompanyField" :
          let result$3 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.company, validators_company, status => {
            let init = state.fieldsStatuses;
            return {
              email: init.email,
              phone: init.phone,
              website: init.website,
              company: status,
              displayName: init.displayName,
              lastName: init.lastName,
              firstName: init.firstName
            };
          });
          if (result$3 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$3,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurDisplayNameField" :
          let result$4 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.displayName, validators_displayName, status => {
            let init = state.fieldsStatuses;
            return {
              email: init.email,
              phone: init.phone,
              website: init.website,
              company: init.company,
              displayName: status,
              lastName: init.lastName,
              firstName: init.firstName
            };
          });
          if (result$4 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$4,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurLastNameField" :
          let result$5 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.lastName, validators_lastName, status => {
            let init = state.fieldsStatuses;
            return {
              email: init.email,
              phone: init.phone,
              website: init.website,
              company: init.company,
              displayName: init.displayName,
              lastName: status,
              firstName: init.firstName
            };
          });
          if (result$5 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$5,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurFirstNameField" :
          let result$6 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.firstName, validators_firstName, status => {
            let init = state.fieldsStatuses;
            return {
              email: init.email,
              phone: init.phone,
              website: init.website,
              company: init.company,
              displayName: init.displayName,
              lastName: init.lastName,
              firstName: status
            };
          });
          if (result$6 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$6,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "Submit" :
          let match = state.formStatus;
          if (typeof match === "object" && match.TAG === "Submitting") {
            return "NoUpdate";
          }
          let apply_validate = validateForm;
          let match$1 = apply_validate(state.input, validators, state.fieldsStatuses, metadata);
          switch (match$1.TAG) {
            case "Valid" :
              let output = match$1.output;
              let error = state.formStatus;
              let tmp;
              tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : error._0;
              return {
                TAG: "UpdateWithSideEffects",
                _0: {
                  input: state.input,
                  fieldsStatuses: match$1.fieldsStatuses,
                  collectionsStatuses: match$1.collectionsStatuses,
                  formStatus: {
                    TAG: "Submitting",
                    _0: tmp
                  },
                  submissionStatus: "AttemptedToSubmit"
                },
                _1: param => {
                  let dispatch = param.dispatch;
                  onSubmit(output, {
                    notifyOnSuccess: input => dispatch({
                      TAG: "SetSubmittedStatus",
                      _0: input
                    }),
                    notifyOnFailure: error => dispatch({
                      TAG: "SetSubmissionFailedStatus",
                      _0: error
                    }),
                    reset: () => dispatch("Reset"),
                    dismissSubmissionResult: () => dispatch("DismissSubmissionResult")
                  });
                }
              };
            case "Invalid" :
              return {
                TAG: "Update",
                _0: {
                  input: state.input,
                  fieldsStatuses: match$1.fieldsStatuses,
                  collectionsStatuses: match$1.collectionsStatuses,
                  formStatus: "Editing",
                  submissionStatus: "AttemptedToSubmit"
                }
              };
            case "Validating" :
              return {
                TAG: "Update",
                _0: {
                  input: state.input,
                  fieldsStatuses: match$1.fieldsStatuses,
                  collectionsStatuses: match$1.collectionsStatuses,
                  formStatus: state.formStatus,
                  submissionStatus: state.submissionStatus
                }
              };
          }
          break;
        case "DismissSubmissionError" :
          let match$2 = state.formStatus;
          if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
            return "NoUpdate";
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "DismissSubmissionResult" :
          let match$3 = state.formStatus;
          if (typeof match$3 !== "object") {
            if (match$3 === "Editing") {
              return "NoUpdate";
            }
          } else if (match$3.TAG === "Submitting") {
            return "NoUpdate";
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: "Editing",
              submissionStatus: state.submissionStatus
            }
          };
        case "Reset" :
          return {
            TAG: "Update",
            _0: initialState(initialInput)
          };
      }
    } else {
      switch (action.TAG) {
        case "UpdateEmailField" :
          let nextInput = action._0(state.input);
          let nextFieldsStatuses = Formality.Async.validateFieldOnChangeInOnChangeModeWithMetadata(nextInput, metadata, state.fieldsStatuses.email, state.submissionStatus, validators_email, status => {
            let init = state.fieldsStatuses;
            return {
              email: status,
              phone: init.phone,
              website: init.website,
              company: init.company,
              displayName: init.displayName,
              lastName: init.lastName,
              firstName: init.firstName
            };
          });
          let value$2 = nextFieldsStatuses.email;
          if (typeof value$2 === "object" && value$2.TAG !== "Dirty") {
            let value$3 = value$2._0;
            return {
              TAG: "UpdateWithSideEffects",
              _0: {
                input: nextInput,
                fieldsStatuses: nextFieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              },
              _1: param => validators_email.validateAsync([
                value$3,
                metadata,
                param.dispatch
              ])
            };
          }
          return {
            TAG: "Update",
            _0: {
              input: nextInput,
              fieldsStatuses: nextFieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdatePhoneField" :
          let nextInput$1 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$1,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$1, metadata, state.fieldsStatuses.phone, state.submissionStatus, validators_phone, status => {
                let init = state.fieldsStatuses;
                return {
                  email: init.email,
                  phone: status,
                  website: init.website,
                  company: init.company,
                  displayName: init.displayName,
                  lastName: init.lastName,
                  firstName: init.firstName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateWebsiteField" :
          let nextInput$2 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$2,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$2, metadata, state.fieldsStatuses.website, state.submissionStatus, validators_website, status => {
                let init = state.fieldsStatuses;
                return {
                  email: init.email,
                  phone: init.phone,
                  website: status,
                  company: init.company,
                  displayName: init.displayName,
                  lastName: init.lastName,
                  firstName: init.firstName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateCompanyField" :
          let nextInput$3 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$3,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$3, metadata, state.fieldsStatuses.company, state.submissionStatus, validators_company, status => {
                let init = state.fieldsStatuses;
                return {
                  email: init.email,
                  phone: init.phone,
                  website: init.website,
                  company: status,
                  displayName: init.displayName,
                  lastName: init.lastName,
                  firstName: init.firstName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateDisplayNameField" :
          let nextInput$4 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$4,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$4, metadata, state.fieldsStatuses.displayName, state.submissionStatus, validators_displayName, status => {
                let init = state.fieldsStatuses;
                return {
                  email: init.email,
                  phone: init.phone,
                  website: init.website,
                  company: init.company,
                  displayName: status,
                  lastName: init.lastName,
                  firstName: init.firstName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateLastNameField" :
          let nextInput$5 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$5,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$5, metadata, state.fieldsStatuses.lastName, state.submissionStatus, validators_lastName, status => {
                let init = state.fieldsStatuses;
                return {
                  email: init.email,
                  phone: init.phone,
                  website: init.website,
                  company: init.company,
                  displayName: init.displayName,
                  lastName: status,
                  firstName: init.firstName
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateFirstNameField" :
          let nextInput$6 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$6,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$6, metadata, state.fieldsStatuses.firstName, state.submissionStatus, validators_firstName, status => {
                let init = state.fieldsStatuses;
                return {
                  email: init.email,
                  phone: init.phone,
                  website: init.website,
                  company: init.company,
                  displayName: init.displayName,
                  lastName: init.lastName,
                  firstName: status
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "ApplyAsyncResultForEmailField" :
          let validator = validators_email;
          let x = state.fieldsStatuses.email;
          if (typeof x !== "object") {
            return "NoUpdate";
          }
          if (x.TAG === "Dirty") {
            return "NoUpdate";
          }
          if (!validator.eq(x._0, action._0)) {
            return "NoUpdate";
          }
          let init = state.fieldsStatuses;
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: {
                email: {
                  TAG: "Dirty",
                  _0: action._1,
                  _1: "Shown"
                },
                phone: init.phone,
                website: init.website,
                company: init.company,
                displayName: init.displayName,
                lastName: init.lastName,
                firstName: init.firstName
              },
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "SetSubmittedStatus" :
          let input = action._0;
          if (input !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: input,
                fieldsStatuses: initialFieldsStatuses(input),
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: initialFieldsStatuses(state.input),
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "SetSubmissionFailedStatus" :
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: {
                TAG: "SubmissionFailed",
                _0: action._0
              },
              submissionStatus: state.submissionStatus
            }
          };
        case "MapSubmissionError" :
          let map = action._0;
          let error$1 = state.formStatus;
          if (typeof error$1 !== "object") {
            return "NoUpdate";
          }
          if (error$1.TAG !== "Submitting") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "SubmissionFailed",
                  _0: map(error$1._0)
                },
                submissionStatus: state.submissionStatus
              }
            };
          }
          let error$2 = error$1._0;
          if (error$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "Submitting",
                  _0: map(error$2)
                },
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
      }
    }
  });
  let dispatch = match[1];
  let state = match[0];
  let match$1 = state.formStatus;
  let tmp;
  tmp = typeof match$1 !== "object" ? false : match$1.TAG === "Submitting";
  return {
    updateEmail: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateEmailField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updatePhone: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdatePhoneField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateWebsite: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateWebsiteField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateCompany: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateCompanyField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateDisplayName: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateDisplayNameField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateLastName: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateLastNameField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateFirstName: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateFirstNameField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    blurEmail: () => dispatch("BlurEmailField"),
    blurPhone: () => dispatch("BlurPhoneField"),
    blurWebsite: () => dispatch("BlurWebsiteField"),
    blurCompany: () => dispatch("BlurCompanyField"),
    blurDisplayName: () => dispatch("BlurDisplayNameField"),
    blurLastName: () => dispatch("BlurLastNameField"),
    blurFirstName: () => dispatch("BlurFirstNameField"),
    emailResult: Formality.Async.exposeFieldResult(state.fieldsStatuses.email),
    phoneResult: Formality.exposeFieldResult(state.fieldsStatuses.phone),
    websiteResult: Formality.exposeFieldResult(state.fieldsStatuses.website),
    companyResult: Formality.exposeFieldResult(state.fieldsStatuses.company),
    displayNameResult: Formality.exposeFieldResult(state.fieldsStatuses.displayName),
    lastNameResult: Formality.exposeFieldResult(state.fieldsStatuses.lastName),
    firstNameResult: Formality.exposeFieldResult(state.fieldsStatuses.firstName),
    input: state.input,
    status: state.formStatus,
    dirty: () => {
      let match = state.fieldsStatuses;
      let tmp = match.email;
      if (typeof tmp === "object") {
        return true;
      }
      let tmp$1 = match.phone;
      if (typeof tmp$1 === "object") {
        return true;
      }
      let tmp$2 = match.website;
      if (typeof tmp$2 === "object") {
        return true;
      }
      let tmp$3 = match.company;
      if (typeof tmp$3 === "object") {
        return true;
      }
      let tmp$4 = match.displayName;
      if (typeof tmp$4 === "object") {
        return true;
      }
      let tmp$5 = match.lastName;
      if (typeof tmp$5 === "object") {
        return true;
      }
      let tmp$6 = match.firstName;
      return typeof tmp$6 === "object";
    },
    valid: () => {
      let apply_validate = validateForm;
      let match = apply_validate(state.input, validators, state.fieldsStatuses, metadata);
      switch (match.TAG) {
        case "Valid" :
          return true;
        case "Invalid" :
          return false;
        case "Validating" :
          return;
      }
    },
    submitting: tmp,
    submit: () => dispatch("Submit"),
    dismissSubmissionError: () => dispatch("DismissSubmissionError"),
    dismissSubmissionResult: () => dispatch("DismissSubmissionResult"),
    mapSubmissionError: map => dispatch({
      TAG: "MapSubmissionError",
      _0: map
    }),
    reset: () => dispatch("Reset")
  };
}

let FormConfig = {
  debounceInterval: 700,
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialFieldStatuses_xxx: initialFieldStatuses_xxx,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

let convertVariables$2 = ProfilePagePersonalInformationForm_UpdateAgentProfilePersonalInfoMutation_graphql.Internal.convertVariables;

let convertResponse$2 = ProfilePagePersonalInformationForm_UpdateAgentProfilePersonalInfoMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$2 = ProfilePagePersonalInformationForm_UpdateAgentProfilePersonalInfoMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$1 = RescriptRelay_Mutation.commitMutation(convertVariables$2, ProfilePagePersonalInformationForm_UpdateAgentProfilePersonalInfoMutation_graphql.node, convertResponse$2, convertWrapRawResponse$2);

let use$2 = RescriptRelay_Mutation.useMutation(convertVariables$2, ProfilePagePersonalInformationForm_UpdateAgentProfilePersonalInfoMutation_graphql.node, convertResponse$2, convertWrapRawResponse$2);

let UpdateAgentProfilePersonalInfoMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$2,
  convertResponse: convertResponse$2,
  convertWrapRawResponse: convertWrapRawResponse$2,
  commitMutation: commitMutation$1,
  use: use$2
};

let convertFragment = ProfilePagePersonalInformationForm_agent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ProfilePagePersonalInformationForm_agent_graphql.node, convertFragment, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(ProfilePagePersonalInformationForm_agent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ProfilePagePersonalInformationForm_agent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ProfilePagePersonalInformationForm_agent_graphql.node, convertFragment, fRef);
}

let AgentFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$3,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ProfilePagePersonalInformationForm(props) {
  let agent = RescriptRelay_Fragment.useFragment(ProfilePagePersonalInformationForm_agent_graphql.node, convertFragment, props.agent);
  let match = use$2();
  let updateAgentPersonalInfo = match[0];
  let match$1 = React.useState(() => agent.brokerage);
  let setInitialBrokerage = match$1[1];
  let form = useForm({
    firstName: Stdlib_Option.getOr(agent.firstName, ""),
    lastName: Stdlib_Option.getOr(agent.lastName, ""),
    displayName: agent.userEnteredDisplayName,
    company: Stdlib_Option.getOr(agent.brokerage, ""),
    website: Stdlib_Option.map(agent.website, w => Scalars.URL.toString(w)),
    phone: agent.phone,
    email: Stdlib_Option.getOr(Stdlib_Option.map(agent.emailAddress, e => Scalars.EmailAddress.toString(e)), "")
  }, {
    validateEmail: validate,
    initialEmail: Stdlib_Option.getOr(Stdlib_Option.map(agent.emailAddress, e => Scalars.EmailAddress.toString(e)), "")
  }, (param, param$1) => {
    let notifyOnFailure = param$1.notifyOnFailure;
    let notifyOnSuccess = param$1.notifyOnSuccess;
    let company = param.company;
    updateAgentPersonalInfo({
      input: {
        company: company,
        displayName: param.displayName,
        email: param.email,
        firstName: param.firstName,
        lastName: param.lastName,
        phone: param.phone,
        website: param.website
      }
    }, undefined, undefined, undefined, (param, param$1) => {
      let updateAgentProfilePersonalInfo = param.updateAgentProfilePersonalInfo;
      if (updateAgentProfilePersonalInfo === undefined) {
        return notifyOnFailure("Error updating data. Please refresh and try again...");
      }
      if (updateAgentProfilePersonalInfo.__typename !== "Agent") {
        return notifyOnFailure("Error updating data. Please refresh and try again...");
      }
      notifyOnSuccess(undefined);
      setInitialBrokerage(param => company);
    }, undefined, undefined);
  });
  let disabled = match[1] || form.submitting;
  let match$2 = form.firstNameResult;
  let tmp;
  tmp = match$2 !== undefined && match$2.TAG !== "Ok" ? ({
      NAME: "Error",
      VAL: match$2._0
    }) : undefined;
  let match$3 = form.lastNameResult;
  let tmp$1;
  tmp$1 = match$3 !== undefined && match$3.TAG !== "Ok" ? ({
      NAME: "Error",
      VAL: match$3._0
    }) : undefined;
  let match$4 = form.displayNameResult;
  let tmp$2;
  tmp$2 = match$4 !== undefined && match$4.TAG !== "Ok" ? ({
      NAME: "Error",
      VAL: match$4._0
    }) : undefined;
  let match$5 = form.companyResult;
  let tmp$3;
  tmp$3 = match$5 !== undefined && match$5.TAG !== "Ok" ? ({
      NAME: "Error",
      VAL: match$5._0
    }) : undefined;
  let match$6 = form.websiteResult;
  let tmp$4;
  tmp$4 = match$6 !== undefined && match$6.TAG !== "Ok" ? ({
      NAME: "Error",
      VAL: match$6._0
    }) : undefined;
  let match$7 = form.phoneResult;
  let tmp$5;
  tmp$5 = match$7 !== undefined && match$7.TAG !== "Ok" ? ({
      NAME: "Error",
      VAL: match$7._0
    }) : undefined;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(ProfilePagePersonalInformationForm$ForceBrokerageDialog, {
        company: match$1[0],
        setCompanyInForm: company => {
          form.updateCompany((v, value) => ({
            firstName: v.firstName,
            lastName: v.lastName,
            displayName: v.displayName,
            company: value,
            website: v.website,
            phone: v.phone,
            email: v.email
          }), company);
          setInitialBrokerage(param => company);
        }
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              "Contact Information",
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(Form__Components.FormStatusMessageV2.make, {
                  status: form.status,
                  submissionErrorToString: v => v,
                  onSuccessMessage: "Account updated",
                  resetForm: form.reset,
                  dismissSubmissionResult: form.dismissSubmissionResult
                }),
                className: "my-4"
              })
            ],
            className: "text-2xl border-b pb-4 font-semibold mb-8"
          }),
          JsxRuntime.jsxs(FormV5.FormGroup.make, {
            label: "First name:",
            children: [
              JsxRuntime.jsx(Form__Input.make, {
                type: "text",
                onChange: event => form.updateFirstName((v, value) => ({
                  firstName: value,
                  lastName: v.lastName,
                  displayName: v.displayName,
                  company: v.company,
                  website: v.website,
                  phone: v.phone,
                  email: v.email
                }), event.target.value),
                onBlur: param => form.blurFirstName(),
                disabled: form.submitting,
                status: Stdlib_Option.map(form.firstNameResult, x => {
                  if (x.TAG === "Ok") {
                    return "ok";
                  } else {
                    return "error";
                  }
                }),
                value: form.input.firstName
              }),
              JsxRuntime.jsx(Form__Components.FieldError.make, {
                valid: tmp
              })
            ]
          }),
          JsxRuntime.jsxs(FormV5.FormGroup.make, {
            label: "Last name:",
            children: [
              JsxRuntime.jsx(Form__Input.make, {
                type: "text",
                onChange: event => form.updateLastName((v, value) => ({
                  firstName: v.firstName,
                  lastName: value,
                  displayName: v.displayName,
                  company: v.company,
                  website: v.website,
                  phone: v.phone,
                  email: v.email
                }), event.target.value),
                onBlur: param => form.blurLastName(),
                disabled: form.submitting,
                status: Stdlib_Option.map(form.lastNameResult, x => {
                  if (x.TAG === "Ok") {
                    return "ok";
                  } else {
                    return "error";
                  }
                }),
                value: form.input.lastName
              }),
              JsxRuntime.jsx(Form__Components.FieldError.make, {
                valid: tmp$1
              })
            ]
          }),
          JsxRuntime.jsxs(FormV5.FormGroup.make, {
            label: "Display name:",
            children: [
              JsxRuntime.jsx(Form__Input.make, {
                type: "text",
                onChange: event => {
                  let newDisplayName = event.target.value;
                  form.updateDisplayName((v, value) => ({
                    firstName: v.firstName,
                    lastName: v.lastName,
                    displayName: Form__Helpers.noneIfEmpty(value),
                    company: v.company,
                    website: v.website,
                    phone: v.phone,
                    email: v.email
                  }), newDisplayName);
                },
                onBlur: param => form.blurDisplayName(),
                disabled: form.submitting,
                status: Stdlib_Option.map(form.displayNameResult, x => {
                  if (x.TAG === "Ok") {
                    return "ok";
                  } else {
                    return "error";
                  }
                }),
                value: Stdlib_Option.getOr(form.input.displayName, "")
              }),
              JsxRuntime.jsx(Form__Components.FieldError.make, {
                valid: tmp$2
              })
            ]
          }),
          JsxRuntime.jsxs(FormV5.FormGroup.make, {
            label: "Brokerage:",
            children: [
              JsxRuntime.jsx(Form__Input.make, {
                type: "text",
                onChange: event => {
                  let newCompany = event.target.value;
                  form.updateCompany((v, value) => ({
                    firstName: v.firstName,
                    lastName: v.lastName,
                    displayName: v.displayName,
                    company: value,
                    website: v.website,
                    phone: v.phone,
                    email: v.email
                  }), newCompany);
                },
                onBlur: param => form.blurCompany(),
                disabled: form.submitting,
                status: Stdlib_Option.map(form.companyResult, x => {
                  if (x.TAG === "Ok") {
                    return "ok";
                  } else {
                    return "error";
                  }
                }),
                value: form.input.company
              }),
              JsxRuntime.jsx(Form__Components.FieldError.make, {
                valid: tmp$3
              })
            ]
          }),
          JsxRuntime.jsxs(FormV5.FormGroup.make, {
            label: "Website:",
            children: [
              JsxRuntime.jsx(Form__Input.make, {
                type: "text",
                onChange: event => form.updateWebsite((v, value) => ({
                  firstName: v.firstName,
                  lastName: v.lastName,
                  displayName: v.displayName,
                  company: v.company,
                  website: value,
                  phone: v.phone,
                  email: v.email
                }), event.target.value),
                onBlur: param => {
                  let match = form.websiteResult;
                  if (match !== undefined && match.TAG !== "Ok") {
                    form.updateWebsite((v, value) => ({
                      firstName: v.firstName,
                      lastName: v.lastName,
                      displayName: v.displayName,
                      company: v.company,
                      website: value,
                      phone: v.phone,
                      email: v.email
                    }), Form__Helpers.addHttp(Stdlib_Option.getOr(form.input.website, "")));
                  }
                  form.blurWebsite();
                },
                disabled: form.submitting,
                status: Stdlib_Option.map(form.websiteResult, x => {
                  if (x.TAG === "Ok") {
                    return "ok";
                  } else {
                    return "error";
                  }
                }),
                value: Stdlib_Option.getOr(form.input.website, "")
              }),
              JsxRuntime.jsx(Form__Components.FieldError.make, {
                valid: tmp$4
              })
            ]
          }),
          JsxRuntime.jsxs(FormV5.FormGroup.make, {
            label: "Phone:",
            children: [
              JsxRuntime.jsx(Form__Input.make, {
                type: "text",
                onChange: event => {
                  let value = event.target.value;
                  form.updatePhone((v, value) => ({
                    firstName: v.firstName,
                    lastName: v.lastName,
                    displayName: v.displayName,
                    company: v.company,
                    website: v.website,
                    phone: value,
                    email: v.email
                  }), Form__Helpers.noneIfEmpty(Form__Helpers.stripNonDigits(value).slice(0, 10)));
                },
                onBlur: param => form.blurPhone(),
                disabled: form.submitting,
                status: Stdlib_Option.map(form.phoneResult, x => {
                  if (x.TAG === "Ok") {
                    return "ok";
                  } else {
                    return "error";
                  }
                }),
                value: Form__Helpers.formatAsPhone(Stdlib_Option.getOr(form.input.phone, ""))
              }),
              JsxRuntime.jsx(Form__Components.FieldError.make, {
                valid: tmp$5
              })
            ]
          }),
          JsxRuntime.jsxs(FormV5.FormGroup.make, {
            label: "Email:",
            children: [
              JsxRuntime.jsx(Form__Input.make, {
                placeholderText: "Enter your email",
                onChange: event => form.updateEmail((v, value) => ({
                  firstName: v.firstName,
                  lastName: v.lastName,
                  displayName: v.displayName,
                  company: v.company,
                  website: v.website,
                  phone: v.phone,
                  email: value
                }), event.target.value),
                onBlur: param => form.blurEmail(),
                disabled: false,
                status: Form__Helpers.resultAsyncToStatus(form.emailResult),
                value: form.input.email
              }),
              JsxRuntime.jsx(Form__Components.FieldErrorAsyncV2.make, {
                valid: form.emailResult
              })
            ]
          }),
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
              onClick: extra => Form__Helpers.preventDefault(form.submit, extra),
              disabled: disabled,
              children: "Save"
            })
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                children: "Preview",
                className: "text-lg font-semibold mb-2"
              }),
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(AgentInfo.make, {
                  agent: agent.fragmentRefs,
                  overrideBrokerage: form.input.company,
                  overrideDisplayName: Stdlib_Option.getOr(form.input.displayName, form.input.firstName + ` ` + form.input.lastName),
                  linkToAgent: false,
                  size: "medium"
                }),
                className: "p-4 border"
              })
            ],
            className: "mt-8"
          })
        ],
        className: "flex flex-col my-8"
      })
    ]
  });
}

let make = ProfilePagePersonalInformationForm;

exports.ForceBrokerageDialog = ForceBrokerageDialog;
exports.ValidateEmailAsync = ValidateEmailAsync;
exports.FormConfig = FormConfig;
exports.UpdateAgentProfilePersonalInfoMutation = UpdateAgentProfilePersonalInfoMutation;
exports.AgentFragment = AgentFragment;
exports.make = make;
/* commitMutation Not a pure module */
